import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "@/components/Button";
import { useAuth } from "@/lib/auth/AuthProvider";

interface LocationState {
  from?: string;
}

export default function Login() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const fromPath = (location.state as LocationState | null)?.from ?? "/dashboard";

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await signIn(username, password);
      navigate(fromPath, { replace: true });
    } catch (e) {
      setErr((e as Error).message);
      setBusy(false);
    }
  };

  return (
    <div className="flex h-full items-center justify-center bg-surface p-6">
      <form
        onSubmit={submit}
        className="w-full max-w-sm space-y-4 rounded-lg border border-border bg-surface-elev p-6"
      >
        <div>
          <img src="/bluerock-logo.svg" alt="BlueRock" className="h-7 w-auto" />
          <div className="mt-1 text-xs text-text-muted">Self-Hosted Console</div>
        </div>
        <label className="block">
          <span className="mb-1 block text-sm font-medium">Email</span>
          <input
            autoFocus
            required
            autoComplete="username"
            className="w-full rounded border border-border bg-surface px-3 py-2 text-sm"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </label>
        <label className="block">
          <span className="mb-1 block text-sm font-medium">Password</span>
          <input
            required
            type="password"
            autoComplete="current-password"
            className="w-full rounded border border-border bg-surface px-3 py-2 text-sm"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {err && (
          <div className="rounded border border-danger/40 bg-danger/10 p-2 text-xs text-danger">
            {err}
          </div>
        )}
        <Button type="submit" variant="primary" disabled={busy} className="w-full">
          {busy ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </div>
  );
}
